module.exports = __webpack_public_path__ + "img/scorestar_gray.d356377b.svg";